import type { Infer } from 'superstruct';
import { boolean, number, object, omit, string } from 'superstruct';

import { EditPermissionsDto } from '@adflow/shared/util-data';

export const ViewRoleDto = object({
	name: string(),
	superuser: boolean(),
	permissions: EditPermissionsDto,
	id: number(),
	archived: boolean(),
	isAdmin: boolean(),
});

export type ViewRoleDto = Infer<typeof ViewRoleDto>;

export const ViewRoleListedDto = omit(ViewRoleDto, ['permissions']);

export type ViewRoleListedDto = Infer<typeof ViewRoleListedDto>;
